import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services/xena-client/xena-client.service';
import { ICountry } from 'src/app/xena-api/dtos';
import { IQueryStringFilter, defaultQueryStringFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private xenaClient: XenaClient) { }

  list(filter: IQueryStringFilter = defaultQueryStringFilter): Observable<Page<ICountry>> {
    const resourcePath: string = '/Country';
    return this.xenaClient.list<ICountry, IQueryStringFilter>(resourcePath, filter);
  }
}
